export interface PricingPlan {
  id: "free" | "plus" | "family";
  name: string;
  tagline: string;
  monthly: number;
  yearly: number;
  features: string[];
  highlight?: boolean;
}

export const pricingPlans: PricingPlan[] = [
  {
    id: "free",
    name: "Free",
    tagline: "Everything you need to start talking.",
    monthly: 0,
    yearly: 0,
    features: ["1 active course pair", "All 7 game types", "Translator with 50 saved words", "5 hearts per lesson"],
  },
  {
    id: "plus",
    name: "Plus",
    tagline: "For people who practise most days.",
    monthly: 9.99,
    yearly: 5.99,
    highlight: true,
    features: [
      "Unlimited course pairs",
      "Unlimited hearts",
      "Unlimited saved words",
      "Full Loescher book, offline",
      "Word-by-word pronunciation feedback",
    ],
  },
  {
    id: "family",
    name: "Family",
    tagline: "Up to 6 learners, one bill.",
    monthly: 14.99,
    yearly: 9.99,
    features: ["Everything in Plus", "6 separate profiles", "Shared family dashboard", "Weekly progress reports"],
  },
];

export interface ComparisonRow {
  feature: string;
  free: boolean | string;
  plus: boolean | string;
  family: boolean | string;
}

export const comparisonRows: ComparisonRow[] = [
  { feature: "Course pairs", free: "1", plus: "Unlimited", family: "Unlimited" },
  { feature: "Game types", free: "All 7", plus: "All 7", family: "All 7" },
  { feature: "Hearts per lesson", free: "5", plus: "Unlimited", family: "Unlimited" },
  { feature: "Translator saved words", free: "50", plus: "Unlimited", family: "Unlimited" },
  { feature: "Saved words blended into lessons", free: true, plus: true, family: true },
  { feature: "Loescher book chapters", free: "First 2 per course", plus: "All", family: "All" },
  { feature: "Offline reading & lessons", free: false, plus: true, family: true },
  { feature: "Pronunciation feedback", free: "Basic", plus: "Word by word", family: "Word by word" },
  { feature: "Profiles", free: "1", plus: "1", family: "6" },
  { feature: "Ad-free", free: false, plus: true, family: true },
];

export const billingHistory = [
  { id: "inv-0926", date: "Sep 1, 2026", description: "PolyLexa Plus · monthly", amount: "€9.99", status: "Paid" },
  { id: "inv-0826", date: "Aug 1, 2026", description: "PolyLexa Plus · monthly", amount: "€9.99", status: "Paid" },
  { id: "inv-0726", date: "Jul 1, 2026", description: "PolyLexa Plus · monthly", amount: "€9.99", status: "Paid" },
  { id: "inv-0626", date: "Jun 1, 2026", description: "PolyLexa Plus · monthly", amount: "€9.99", status: "Refunded" },
];
